export default "__VITE_ASSET__CcjlUlZx__"